import React, { Component } from 'react'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import Button from '@components/Button'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'

import { hfComplianceApi, projectApi } from '@atheneum/api'
import { Autocomplete } from '@components/Form/Autocomplete'
import FormError from '@components/FormError'
import { downloadFromUrl, tokenStorage, exportDialogMessage } from '@atheneum/api/dist/lib'

import './HFCompliancePdfExportModal.sass'
import get from 'lodash/get'

const EXPORT_WITH_COMMENTS = true
const EXPORT_WITHOUT_COMMENTS = false

class HFCompliancePdfExportModal extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, {
      job: null,
      error: null
    })
  }

  handleProjectAutocomplete = input =>
    projectApi
      .typeaheadSearch(input, { onlyHedgeFundProjects: true })
      .then(results =>
        results.map(({ projectName, id, projectTypeId }) => ({
          value: id,
          label: projectName,
          projectTypeId
        }))
      )

  exportPdf = async (values, exportType) => {
    this.error = null
    const { queueProcessorStore, hfCompliance } = this.props
    // as we have two 'submit' buttons,
    // built-in validation is useless here as it cannot be triggered manually via validateForm()
    // nor can we pass data to onSubmit to toggle the 'with/without comments' export
    if (!values.project) {
      this.error = 'Project is required'
      return
    }

    const { jobId } = await hfComplianceApi.exportHfCompliance({
      hfComplianceId: hfCompliance.id,
      withComments: exportType,
      projectName: values.project.label
    })

    const filename = `${this.props.expertName}-hfCompliance.pdf`

    queueProcessorStore.trackJob(jobId, ({ url }) =>
      downloadFromUrl({ url: `${url}?token=${tokenStorage.get()}`, filename })
    )

    this.job = queueProcessorStore.jobs[jobId]

    await exportDialogMessage({ exportType: 'HF compliance PDF' })
  }

  render () {
    const job = this.job
    const loading = get(job, 'loading')
    const { modalStore } = this.props
    return (
      <div className='expert-form'>
        <h1>Export Hedge fund compliance form</h1>
        <Formik
          initialValues={{
            project: null
          }}
          render={({ values }) => (
            <Form>
              <FormError error={this.error} />
              <div className='expert-form__input-group project-input'>
                <Field
                  name='project'
                  label='Project*'
                  component={Autocomplete}
                  loadOptions={input => this.handleProjectAutocomplete(input)}
                  itemToString={item => item && item.label}
                />
              </div>
              <div className='expert-form__section expert-form__section--buttons'>
                <Button
                  primary
                  onClick={() => this.exportPdf(values, EXPORT_WITH_COMMENTS)}
                  disabled={loading}
                >
                  Export
                </Button>
                <Button
                  onClick={() =>
                    this.exportPdf(values, EXPORT_WITHOUT_COMMENTS)
                  }
                  disabled={loading}
                >
                  Export without comments
                </Button>
                <Button onClick={modalStore.close} disabled={loading}>
                  Cancel
                </Button>
              </div>
            </Form>
          )}
        />
      </div>
    )
  }

  static propTypes = {
    modalStore: PropTypes.object,
    hfCompliance: PropTypes.object,
    queueProcessorStore: PropTypes.object,
    expertName: PropTypes.string
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: false,
    shouldCloseOnOverlayClick: false
  }
}

export default inject('modalStore', 'queueProcessorStore', 'growlStore')(
  observer(HFCompliancePdfExportModal)
)
